import { type UseQueryResult, useQuery } from 'react-query';
import {
  MyHoldingsOverviewService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_MyHoldings_CustomerHoldingsDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetHoldingForCustomer = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  awardId: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_MyHoldings_CustomerHoldingsDto[] | undefined,
  unknown
> => {
  const holdingList = useQuery(['getHoldingList'], async () => {
    return await handleRequest(
      MyHoldingsOverviewService.getApiAwardApiAppMyHoldingsHoldingsForCustomer(awardId)
    );
  });
  return holdingList;
};

export default useGetHoldingForCustomer;
